import React from 'react';
import cn from 'bem-cn';

import { PromptStatus } from '@ai-platform/utils';
import { StatusProps } from './Status.types';

import './Status.scss';

const b = cn('status');

export const Status: React.FC<StatusProps> = ({ status }) => {
    const getStatusText = (status: string): string => {
        switch (status) {
            case PromptStatus.Published:
                return 'Опубликован';
            case PromptStatus.Rejected:
                return 'Отклонён';
            case PromptStatus.Moderation:
                return 'Модерация';
            case PromptStatus.Postponed:
                return 'Отложен';
            default:
                return status;
        }
    };

    return (
        <span className={b({ status })} data-status={status}>
            {getStatusText(status)}
        </span>
    );
};
